<template>
    <router-view/>
</template>

<script>
    export default {
        name: "Musteri"
    }
</script>

<style scoped>

</style>